import { render, staticRenderFns } from "./InfoDrawer.vue?vue&type=template&id=1d6e0864&"
import script from "./InfoDrawer.vue?vue&type=script&lang=js&"
export * from "./InfoDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports